import isType from './isType'

const isNumber = isType('Number')
export default isNumber
